import script from "./SubTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./SubTasks.vue?vue&type=script&setup=true&lang=js"

import "./SubTasks.vue?vue&type=style&index=0&id=2a7c0806&lang=css"

const __exports__ = script;

export default __exports__